import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum RolePosition {
  BOTTOM = "bottom",
  SIDE = "side",
  TOP = "top",
  VERSATILE = "versatile",
  VERS_BOTTOM = "vers_bottom",
  VERS_TOP = "vers_top",
  OTHER = "other",
  ASK_ME = "ask_me",
}

const ROLE_ATTRIBUTE_OPTIONS: ReadonlyArray<AttributeValue> = [
  { id: RolePosition.BOTTOM, label: "Bottom", iconLabel: "⬇️" },
  { id: RolePosition.SIDE, label: "Side", iconLabel: "↔️" },
  { id: RolePosition.TOP, label: "Top", iconLabel: "⬆️" },
  { id: RolePosition.VERSATILE, label: "Versatile", iconLabel: "↕️" },
  { id: RolePosition.VERS_BOTTOM, label: "Vers Bottom", iconLabel: "↘️" },
  { id: RolePosition.VERS_TOP, label: "Vers Top", iconLabel: "↗️" },
  { id: RolePosition.OTHER, label: "Other", iconLabel: "🔹" },
  { id: RolePosition.ASK_ME, label: "Ask Me", iconLabel: "❓" },
];

export const UserRoleAttributeSet: UserAttributeSet = {
  id: UserAttributeType.ROLE,
  isMultiSelect: false,
  map: attributeListToMap(ROLE_ATTRIBUTE_OPTIONS),
} as const;
